<style>
    .package-header {
        text-align: center;
        padding:12px;
        background:linear-gradient(264.01deg, #B4B4B4 6.65%, #929292 100%);
        color: white;
    }
    .package.selected .package-header {
        background: linear-gradient(99.46deg, #49C5E1 14.86%, #3E82C8 102.08%);
    }
    #star {
        width: 1.25rem;
        padding-left:5px;
    }
</style>

<fadv-card [ngClass]="form.invalid && package.description === 'Standard' ? 'package selected' : form.value.packageID === package.id ? 'package selected' : 'package'" (click)="onClick(package.id)" class="package-detail" [formGroup]="form">
    <fadv-card-header>
        <div class="package-header">
            <fadv-typography type="label-large" weight="500" variant="white">{{package.description}}<img alt="star" *ngIf="package.description === 'Standard'" id="star" src="/assets/icons/star-solid.svg"/></fadv-typography>
        </div>
    </fadv-card-header>
    <fadv-grid>
        <fadv-card-body>
            <fadv-box mt="medium">
                <fadv-box [invert]="true" [mb]="'small'">
                    <fadv-grid-row>
                        <fadv-grid-col alignment="center">
                            <fadv-typography style="display:inline-block;" type="heading-x-large" weight="500">{{package.price | currency}}</fadv-typography>
                            <fadv-typography style="display:inline-block;" type="heading-x-small" weight="400"><sup style="position:relative;top:-12px;left:5px;">each</sup></fadv-typography>
                        </fadv-grid-col>
                    </fadv-grid-row>
                </fadv-box>
                <fadv-box [pt]="'x-small'">
                    <fadv-grid-row>
                        <fadv-grid-col alignment="center">
                            <fadv-typography type="label-medium" weight="500">{{package.turnAroundTime}}</fadv-typography>
                        </fadv-grid-col>
                    </fadv-grid-row>
                </fadv-box>
                <fadv-box [mt]="'x-small'" [invert]="true">
                    <fadv-grid-row>
                        <fadv-grid-col alignment="center">
                            <fadv-typography type="label-x-small" weight="500">Plus out of pocket</fadv-typography>
                        </fadv-grid-col>
                    </fadv-grid-row>
                </fadv-box>
                <fadv-grid-row>
                    <fadv-grid-col alignment="center" style="text-align:left;">
                        <fadv-box mt="small">
                            <fadv-grid [gutter]="'small'">
                                <fadv-grid-row *ngFor="let product of package.productDescriptions">
                                    <fadv-grid-col [col]="1">
                                        <fadv-icon size="x-small" library="solid" name="fa-circle-check" foreground="success" style="padding-right:5px;" >  </fadv-icon>
                                    </fadv-grid-col>
                                    <fadv-grid-col [col]="11" style="padding-left:15px;">
                                        <fadv-typography type="paragraph-x-small" weight="400">{{product.descriptionFA}}</fadv-typography>
                                    </fadv-grid-col>
                                </fadv-grid-row>
                            </fadv-grid>
                        </fadv-box>
                    </fadv-grid-col>
                </fadv-grid-row>
            </fadv-box>
        </fadv-card-body>
        <fadv-grid-row>
            <fadv-grid-col alignment="center" [col]="12" [ngSwitch]="package.id === form.value.packageID">
                <fadv-button *ngSwitchCase="false" style="width:100%;padding:15px 0px" value="package.id" type="button" name="package-select-button">
                    <fadv-typography type="label-medium" weight="500">Select</fadv-typography>
                </fadv-button>
                <fadv-button *ngSwitchCase="true" style="width:100%;padding:15px 0px" value="package.id" variant="primary" type="button" name="package-selected-button">
                    <fadv-icon fadvPrefixIcon library='solid' foreground='white' name='check-double'></fadv-icon>
                    <fadv-typography type="label-medium" variant="white" weight="500">Selected</fadv-typography>
                </fadv-button>
            </fadv-grid-col>
        </fadv-grid-row>
    </fadv-grid>
</fadv-card>
